import {Injectable, inject} from '@angular/core';
import {Observable, of} from 'rxjs';
import {Bizinquiry} from '../../../_data/reports/business/request/bizinquiry';
import {HttpClient} from '@angular/common/http';
import {BusinessPickList, BusinessPickListResponse} from '../../../_data/reports/business/response/business-pick-list';
import {map, tap} from 'rxjs/operators';
import {NotificationService} from '../../gui/notification.service';
import {ApiEndpoints} from '../../../_constants/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class BusinessReportsService {
  private http = inject(HttpClient);
  private notificationService = inject(NotificationService);
  private apiEndpoints = inject(ApiEndpoints);


  private reportPipe(obs: Observable<BusinessPickList>): Observable<BusinessPickListResponse> {
    return obs.pipe(
      map(data => JSON.parse(data.businessResponse)),
      tap(o => {
        if(!o) {
          this.notificationService.displayI18n('content.report.messages.report-failed');
        }
      })
    );
  }

  searchPickList(body: {bizinquiry: Bizinquiry}): Observable<BusinessPickListResponse> {
    console.debug('Searching for business pick list');
    return this.reportPipe(this.http.post<BusinessPickList>(this.apiEndpoints.businessSearchPickList, body));
  }

  getBusinessFromPickList(body: {bizinquiry: Bizinquiry}): Observable<BusinessPickListResponse> {
    console.debug('Getting business from pick list');
    return this.reportPipe(this.http.post<BusinessPickList>(this.apiEndpoints.businessGetBusinessFromPickList, body));
  }

  getBestMatch(body: {bizinquiry: Bizinquiry}): Observable<BusinessPickListResponse> {
    console.debug('Getting business from best match');
    return this.reportPipe(this.http.post<BusinessPickList>(this.apiEndpoints.businessBestMatch, body));
  }

  getReasonDescriptions(...codes: string[]): Observable<{[key: string]: string}> {
    return of(Object.fromEntries(codes.map(code => [code, `${code}`])));
  }

}
